import { useState } from 'react'
import { pb } from '../lib/pocketbase'
import { useSession } from '../hooks/useSession'
import { showToast } from './Toast'
import styles from './EmailVerificationBanner.module.css'

export default function EmailVerificationBanner() {
  const { user } = useSession()
  const [sending, setSending] = useState(false)
  const [dismissed, setDismissed] = useState(false)

  // Don't show if user is verified or banner was dismissed
  if (!user || user.verified || dismissed) return null

  const handleResend = async () => {
    if (sending) return
    setSending(true)

    try {
      await pb.collection('users').requestVerification(user.email)
      showToast('Verification email sent! Check your inbox.', 'success')
    } catch (error: any) {
      showToast(error.message || 'Failed to send verification email', 'error')
    } finally {
      setSending(false)
    }
  }

  return (
    <div className={styles.banner} role="alert">
      <div className={styles.content}>
        <svg className={styles.icon} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
          <polyline points="22,6 12,13 2,6" />
        </svg>
        <span className={styles.message}>
          Please verify your email address to access all features.
        </span>
      </div>
      <div className={styles.actions}>
        <button
          onClick={handleResend}
          disabled={sending}
          className={styles.resendButton}
        >
          {sending ? 'Sending...' : 'Resend Email'}
        </button>
        <button
          onClick={() => setDismissed(true)}
          className={styles.dismissButton}
          aria-label="Dismiss"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
    </div>
  )
}
